<template>
    <div class="about-stickers" :class="{ active_: active }">
        <img class="sticker _n1" src="~@/assets/sticker01.png">
        <img class="sticker _n2" src="~@/assets/sticker02.png">
        <img class="sticker _n3" src="~@/assets/sticker05.png">
        <img class="sticker _n5" src="~@/assets/sticker03.png">
        <img class="sticker _n4" src="~@/assets/sticker04.png">
    </div>
</template>

<script>
export default {
    name: 'AboutLandingStickers',
    data() {
        return {
            active: false
        }
    },
    methods: {
        throwStickers() {
            this.active = true
            return new Promise(resolve => {
                setTimeout(resolve, 1200)
            })
        },
        removeStickers() {
            this.active = false
            return new Promise(resolve => {
                setTimeout(resolve, 1200)
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.about-stickers {
    width: 100%;
    height: 100%;
    position: relative;
    top: 0;
    left: 0;
    z-index: 1;
    &.active_ .sticker {
        transform: none;
        transition-timing-function: $ease;
        visibility: visible;
        &._n5 {
            transform: rotate(30deg);
            @include media(992) {
                transform: none;
            }
        }
    }
}
.sticker {
    position: absolute;
    &._n1 {
        width: dyna(182, 440);
        min-width: 182px;
        top: dyna(34, -120);
        left: dyna(-90, 130);
        transform: translateY(150vh) rotate(-30deg);
        transition: transform 750ms $ease-in;
        @include media(992) {
            top: dyna(-92, -220);
            right: dyna(-32, 112);
            left: auto;
        }
    }
    &._n2 {
        width: dyna(165, 432);
        min-width: 165px;
        top: dyna(0, -220);
        right: dyna(-60, 32);
        transform: translateY(150vh) rotate(-30deg);
        transition: transform 800ms $ease-in;
        transition-delay: 250ms;
        @include media(992) {
            top: dyna(260, 496);
            right: auto;
            left: dyna(0, -84);
        }
    }
    &._n3 {
        width: dyna(208, 428);
        min-width: 208px;
        top: calc(50% + #{dyna(60, 30)});
        left: dyna(-97, -33);
        transform: translateY(150vh) rotate(15deg);
        transition: transform 900ms $ease-in;
        transition-delay: 350ms;
        @include media(992) {
            top: dyna(0, -198);
            left: dyna(-87, 0);
        }
    }
    &._n4 {
        width: dyna(175, 459);
        min-width: 175px;
        top: calc(50% + #{dyna(-30, -70)});
        right: dyna(-90, 0);
        transform: translateY(150vh) rotate(30deg);
        transition: transform 750ms $ease-in;
        transition-delay: 400ms;
        @include media(992) {
            top: auto;
            right: dyna(0, -99);
            bottom: dyna(0, -111);
        }
    }
    &._n5 {
        width: dyna(193, 460);
        min-width: 193px;
        top: calc(50% + 100px);
        right: dyna(-64, 100);
        transform: translateY(150vh) rotate(-20deg);
        transition: transform 700ms $ease-in;
        transition-delay: 520ms;
        @include media(992) {
            top: calc(50% - 230px);
            right: dyna(0, -120);
        }
    }
}
</style>